<template>
  <i
    v-if="iconType === 'icon'"
    :class="`icon-${iconContent} vtd-icon-7`"
  />
</template>

<script>
export default {
  props: {
    brickId: {
      type: String,
      default: ''
    },
    tourType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      iconType: 'icon',
      iconContent: 'information',
    };
  },
  mounted() {
    this.iconContent = this.returnIcon()
  },
  methods: {
    // return material icon based on the type of tour and brick id
    returnIcon() {
      this.iconType = 'icon'

      if (this.brickId === "1") {
        return 'cruise'
      }

      if (this.brickId === "2") {
        if (this.tourType.includes("CRUISE HOLIDAY")) {
          return 'cruise'
        }
        if (this.tourType.includes("SAFARI")) {
          return 'safari'
        }
        if (this.tourType.includes("GROUP")) {
          return 'small_group_tour'
        }
        if (this.tourType.includes("MULTI CENTRE")) {
          return 'trail_notes'
        }
        if (this.tourType.includes("RAIL")) {
          return 'rail'
        }
        if (this.tourType.includes("TRAVEL PASS")) {
          return 'travel_pass'
        }
        if (this.tourType.includes("WILDERNESS")) {
          return 'wilderness_experience'
        }
        if (this.tourType.includes("ATTRACTION TICKETS")) {
          return 'event_tickets'
        }
        if (this.tourType.includes("VOLUNTEER")) {
          return 'volunteer_project'
        }
        if (this.tourType.includes("WORK ABROAD")) {
          return 'work_abroad'
        }
        if (this.tourType.includes("SKILL")) {
          return 'learn_a_skill'
        }
        return 'accomodation'
      }

      if (this.brickId === "3") {
        return 'private_tour'
      }

      if (this.brickId === "4") {
        if (this.tourType.includes("EVENT")) {
          return 'event_tickets'
        }
        if (this.tourType.includes("LOCAL TOUR")) {
          return 'local_tour'
        }
        return 'car_hire'
      }

      if (this.brickId === "5") {
        return 'wedding_package'
      }
      return 'information'
    }
  },
}
</script>

